import { Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { EditSettingsModel, GridComponent, GridLine, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { DocumentGenService } from 'src/app/services/DocumentGen/documentGen.services';
import { CalltrackerService } from 'src/app/services/operations/calltracker.service';
import { StoreService } from 'src/app/services/stores.service';
import { ICallTrackerPhoneCallList, IStore } from '../interface';
import { ISendEmailOutput, ISendEmailOutputModel } from '../interface2';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { DatePipe } from '@angular/common';
import { IReportResponse } from '../models/ReportsModel';
import { ReportsService } from 'src/app/services/operations/reports.service';
import { IHistoryDeails } from '../models/ProspectModel';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { callDurationPipe } from '../duration.pipe';
import { ECallRecordingIntegration, EPhoneSystem, ETransactionTypes, EUserFunctions } from '../enum';
import { FormBuilder, Validators, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { RelinkCallComponent } from '../relink-call/relink-call.component';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';

@Component({
    selector: 'app-callrecording-popup',
    templateUrl: 'callrecording-popup.component.html',
    styleUrls: ['./callrecording-popup.component.scss'],
    standalone: false
})

export class CallRecordingPopupComponent implements OnInit {
  // Exposes the enum to the template for the Twilio Call Sid (no real recording) check.
  ePhoneSystem = EPhoneSystem;
  PhoneCallId = null;
  LeaseNumber = null;
  InquiryNumber = null;
  ReservationNumber = null;
  emailPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  public loaderIcon: Promise<boolean>;
  public todaysdateCall = new Date();
  oldestDate;
  dataForReport = [];
  reportUrl;
  toEmailAddress = '';
  ccEmailAddress = '';
  mailfullContent: ISendEmailOutputModel;
  rteValue: string;
  disableEmailSend = true;
  emailfullContent: ISendEmailOutputModel;
  selectedEmailTemplate = 0;
  emailTemplates = [];
  viewRight: boolean = true;
  viewRightFalseMessage: string;
  public Calldata = [];
  callrecordingData = [];
  minPeriodFromDateCall;
  minPeriodToDateCall;
  periodFromDateCall;
  periodToDateCall;
  selectedAudioURL: string = "";
  selectedTimeOfDay: string = "";
  selectedCallerId: string = "";
  public filterSettings: Object;
  public lines: GridLine;
  public editSettings: EditSettingsModel;
  public initialPage: Object;
  gridSettings;
  StoreName;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  modalRefCall: BsModalRef;
  @Input() tenantId;
  @Input() facilityId;
  @ViewChild('CallRecordings', { static: true }) CallRecordings: ModalDirective;
  @ViewChild('PlayCalltemplate', { static: true }) PlayCalltemplate: ModalDirective;
  @ViewChild('grid', { static: false }) public gridData: GridComponent;
  @ViewChild('EmailModal', { static: true }) emailModal: ModalDirective;
  sendEmailForm: FormGroup;
  viewRightForDownload = false;
  viewRightForEmail = false;
  historyDetails = [];
  selectedLeaseNumber = null;
  selectedRelinkRow: any;
  public audioLoaderIcon: Promise<boolean>;
  audioData;
  callIntegrationId;
  public sortOptions: object;
  constructor(private modalService: BsModalService,
    private callTrackerService: CalltrackerService,
    private storeService: StoreService,
    private documentGenService: DocumentGenService,
    private twoWayService: twoWayService,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private prospectsService: ProspectService,
    private reportService: ReportsService,
    private fb: FormBuilder,
    private userSessionService: UserSessionService,
    private modalWrapper: ModalWrapperService,
) { }

  dataBound(gridData) {
    Object.assign((<any>gridData.filterModule).filterOperators, { startsWith: 'contains' });
  }

  public getData(args) {
    if(args)
    {
      let phonenumber = args;
      const parts = phonenumber.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
      phonenumber = '(' + parts[1] + ')' + parts[2] + '-' + parts[3];
      return phonenumber;
    }
  }

  public created(args1) {
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('TimeOfDay')].classList.add('e-hide');
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('Duration')].classList.add('e-hide');
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('PlayIcon')].classList.add('e-hide');
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('CallerID')].classList.add('e-hide');
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('Tracking#')].classList.add('e-hide');
    this.gridData.element.querySelectorAll('.e-filterdiv')[this.gridData.getColumnIndexByField('Relink')].classList.add('e-hide');
    // this.gridData.element.querySelectorAll('.e-content')[0].classList.add('e-specificHeight');
  }

  ngOnInit() {
    this.sendEmailForm = this.fb.group({
      'toAddress': ['', [Validators.required, this.colonSepToAddressEmail]],
      'ccAddress': ['', [this.colonSepCCAddressEmail]],
    });

    this.editSettings = { allowEditing: false, allowAdding: false, allowDeleting: false };
    this.getStores();
    this.setUserPermissions();
    this.setUserPermissionsDownload();
    this.setUserPermissionsEmail();
    this.getHistory(this.tenantId);
  }

  callAPIs(tenantId, facilityId) {
    this.tenantId = tenantId;
    this.facilityId = facilityId;
    this.getStores();
    this.setUserPermissions();
    this.getReportUrl();
    // this.GetPhoneCallList(this.tenantId, this.facilityId);
    this.UpdateCallDuration();
    this.GetTemplatesforEmailandSMSByTransactionType(this.facilityId, 48);
  }

  UpdateCallDuration() {
    this.callTrackerService.UpdateBatchCallDuration(this.tenantId, null,null).subscribe((response: any) => {
      this.GetPhoneCallList(this.tenantId, this.facilityId);
    }, (err: any) => {
      this.GetPhoneCallList(this.tenantId, this.facilityId);
    });
  }

  GetPhoneCallList(tenantId: any, facilityId: any) {
    this.loaderIcon = Promise.resolve(true);
    const datepipe: DatePipe = new DatePipe('en');
    let objFilter = {
      StartDate: null,
      EndDate: null,
      FacilityId: 0,
      TenantId: tenantId
    }
    this.callTrackerService.GetPhoneCallList(objFilter).subscribe((response: ICallTrackerPhoneCallList[]) => {
      this.callrecordingData = response;
      this.dataForReport = response;
      this.loaderIcon = Promise.resolve(false);
      this.periodToDateCall = new Date();
      this.periodFromDateCall = new Date();
      this.callrecordingData.map((ele) => {
        ele["Route"] = ele.OutboundCall ? "Outbound" : "Inbound";
      });
      this.Calldata = this.callrecordingData;
      if (this.gridData) {
        this.gridData.refresh();
      }
      this.dataForReport.map((item) => {
        item['recordDate'] = datepipe.transform(new Date(item.TimeOfDay), 'MM/dd/yyyy');
      })
      let CallRecordingWithDate = [];
      CallRecordingWithDate = this.dataForReport.filter((item) => item.recordDate);
      const oldestDateObject = CallRecordingWithDate.length ?
        CallRecordingWithDate.reduce((a, b) => (a.recordDate < b.recordDate ? a : b)) : null;
      this.oldestDate = oldestDateObject ? oldestDateObject.recordDate : null;
      if (this.oldestDate) {
        this.periodFromDateCall = this.minPeriodFromDateCall = this.minPeriodToDateCall =
          JSON.parse(JSON.stringify(this.oldestDate));
      }
      this.periodToDateCall = new Date();
      if (this.Calldata) {
        this.created(this.Calldata);
      }

      //this.loaderIcon = Promise.resolve(false);
    }, (err: any) => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  disableGenerateReport() {
    if(!this.viewRight || !this.Calldata.length) {
      return true;
    } else {
      return false;
    }
  }
  rowSelected(args: any, template: any) {
    if (args.data.MissedCall || args.data.VoiceMail || args.data.Duration === "0" ||  args.data.RecordingID?.startsWith('dum_')
      || (args.data.PhoneSystem === this.ePhoneSystem.Twilio && args.data.RecordingID?.startsWith('CA'))) {
      return;
    }
    this.loaderIcon = Promise.resolve(true);
    this.toEmailAddress = '';
    this.ccEmailAddress = '';
    this.selectedEmailTemplate = 0;
    this.mailfullContent = null;
    this.rteValue = "";
    // if (args.target.firstElementChild.id == 'playIcon') {
    const selectedrecords = this.gridData.getSelectedRecords();  // Get the selected records.
    let tempCls = [];
    tempCls = selectedrecords;
    var recordingIds;
    var TimeOfDay;
    var selectedAudioURL = '';
    var callerPhoneNumber = '';
    var phoneSystemId = 0;
    var leaseNumber = null;
    var inquiryNumber = null;
    var reservationNumber = null;
    var phoneCallId = null;
    var callRecordingIntegrationId = "0";
    let facilityId = this.facilityId;
    tempCls.forEach(e => {
      recordingIds = e.RecordingID;
      TimeOfDay = e.TimeOfDay;
      selectedAudioURL = e.MediaPlayURL;
      callerPhoneNumber = e.CallerID;
      phoneSystemId = e.PhoneSystem;
      leaseNumber = e.LeaseNumber;
      inquiryNumber = e.InquiryNumber;
      reservationNumber = e.ReservationNumber;
      phoneCallId = e.PhoneId,
        callRecordingIntegrationId = e.CallCenterIntegrationId;
      facilityId = e.FacilityId
    });
    if(this.userSessionService.isCallcenterAgent) {
      this.facilityId = facilityId;
      this.GetTemplatesforEmailandSMSByTransactionType(this.facilityId, 48);
    }
    if (recordingIds) {
      this.LeaseNumber = leaseNumber;
      this.InquiryNumber = inquiryNumber;
      this.ReservationNumber = reservationNumber;
      this.selectedTimeOfDay = TimeOfDay;
      this.selectedCallerId = recordingIds;
      this.selectedAudioURL = selectedAudioURL;
      this.PhoneCallId = phoneCallId;
      this.getMediaPlayerURL(callerPhoneNumber, phoneSystemId, recordingIds, callRecordingIntegrationId, template);
      // this.CallRecordings.hide();
      // this.modalRefCall = this.modalService.show(template, { class: 'modal-dialog modal-dialog-centered modal-lg' });
    }
    else {
      this.loaderIcon = Promise.resolve(false);
    }
    // }
  }

  getMediaPlayerURL(phoneNo, phoneSystem, callSID, callRecordingIntegrationId, template) {
    this.callIntegrationId = callRecordingIntegrationId;
    this.callTrackerService.getMediaPlayerURL(phoneNo, phoneSystem, callSID, callRecordingIntegrationId).subscribe((response: any) => {
      if (response) {
        this.loaderIcon = Promise.resolve(false);
        this.audioLoaderIcon = Promise.resolve(true);
        if(callRecordingIntegrationId && callRecordingIntegrationId === ECallRecordingIntegration.RCContactCenter) {
          this.selectedAudioURL = `${response}`;
          this.audioData = response;
        } else {
          this.selectedAudioURL = response;
        }
        if (this.emailTemplates.length > 0) {
          this.onChangeEmailTemplate(this.emailTemplates[0].LetterId);
        }
      } else {
        this.audioLoaderIcon = Promise.resolve(false);
        this.toastr.error('Failed to Fetch Call Recording', 'Failure', this.toasterConfig);
      }
      this.loaderIcon = Promise.resolve(false);
      this.CallRecordings.hide();
      this.modalRefCall =     this.modalWrapper.openTemplate(template, { class: 'modal-dialog modal-dialog-centered modal-lg', backdrop: 'static', keyboard: false });
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      var error = err.error && err.error.detail ? JSON.parse(err.error.detail) : null;
      this.toastr.error(error?.message ?? 'Failed to Fetch Call Recording', 'Failure', this.toasterConfig);
    });
  }

  buttonClick() {
    console.log('selected url', this.selectedAudioURL);
    this.CallRecordings.hide();
    this.modalWrapper.openDirective(this.PlayCalltemplate);

  }

  onAudioCancel() {
    this.audioLoaderIcon = Promise.resolve(false);
    this.CallRecordings.show();
    this.modalRefCall.hide();
  }

  getStores() {
    this.storeService.getStores().subscribe((response: IStore[]) => {
      if (this.facilityId !== undefined && this.facilityId !== 0 && this.facilityId !== null) {
        this.StoreName = response.find(o => o.Id == this.facilityId).Name
      }
    });
  }

  GetTemplatesforEmailandSMSByTransactionType(facId, transactionType) {
    this.documentGenService.GetTemplatesforEmailandSMSByTransactionType(facId, transactionType).subscribe((response: any) => {
      this.emailTemplates = response.filter((item) => item.Type == 201);
    });
  }

  onChangeEmailTemplate(templateId) {
    this.selectedEmailTemplate = templateId;
    if (this.selectedEmailTemplate) {
      this.loaderIcon = Promise.resolve(true);
      this.getEmailBody(templateId);
    }
  }

  getEmailBody(id) {
    if (this.InquiryNumber == null && this.ReservationNumber == null && this.LeaseNumber == null) {
      this.LeaseNumber = this.selectedLeaseNumber;
    }
    let obj = {
      InquiryNo: this.InquiryNumber,
      ReservationNo: this.ReservationNumber,
      LeaseNo: this.LeaseNumber,
      FacilityId: this.facilityId,
      ToEmailAddress: '',
      FromEmailAddress: '',
      CCEmailAddress: '',
      BCCEmailAddress: '',
      CCToStoreEmailAddress: '',
      TransactionTypeId: 48,
      InvoiceNumber: 0,
      ReceiptNumber: 0,
      TenantLettersAndNoticesIds: [],
      TenantAlternateLettersAndNoticesIds: [],
      SendToAlternate: true,
      IpAddress: '',
      DripcampaignActionId: 0,
      DripcampaignLetterId: id,
      CollectionCall: false,
      SelectedTemplateId: id,
      LetterIdforCallRecording: id,
      PhoneCallId: this.PhoneCallId,
      CallRecordingURL: this.selectedAudioURL
    };
    this.twoWayService.getBody(obj).subscribe((response: ISendEmailOutputModel) => {
      if (response && response.EmailModel) {
        this.mailfullContent = response;
        this.rteValue = this.mailfullContent.EmailModel.EmailBody;
        this.disableEmailSend = false;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('Failed to fetch the content', 'Failure', this.toasterConfig);
    });
  }

  sendEmail() {
    this.loaderIcon = Promise.resolve(true);
    let emailList = [];
    var firstToAddress: string = this.sendEmailForm.value.toAddress.split(';').length > 1 ? this.sendEmailForm.value.toAddress.split(';')[0] : this.sendEmailForm.value.toAddress;
    var firstCCAddress: string = this.sendEmailForm.value.ccAddress.split(';').length > 1 ? this.sendEmailForm.value.ccAddress.split(';')[0] : this.sendEmailForm.value.ccAddress;
    let emailModel = {
      Subject: this.mailfullContent.EmailModel.Subject,
      EmailBody: this.rteValue,
      FromAddress: this.mailfullContent.EmailModel.FromAddress,
      ToAddress: firstToAddress,
      CcAddress: firstCCAddress,
      BccAddress: this.mailfullContent.EmailModel.BccAddress,
      ToList: this.generateToAddressList(this.sendEmailForm.value.toAddress),
      CcList: this.generateCCAddressList(this.sendEmailForm.value.ccAddress),
      BccList: [],
      Files: this.callIntegrationId === ECallRecordingIntegration.RCContactCenter ? [{
        AttachmentFile: btoa(this.audioData),
        AttachmentFileName: "Video.mp4",
        FileType: "video/mp4"
      }]: [],
    };

    let emailBody = {
      EmailIdentifier: 1,
      EmailModel: emailModel,
      LeaseNo: this.LeaseNumber,
      FacilityId: this.facilityId,
      ReservationNumber: this.ReservationNumber,
      InquiryNumber: this.InquiryNumber,
      FollowUpId: null,
      DripCampaignActionId: null,
      Description: this.mailfullContent.EmailModel.Subject,
      Type: 0,
      TypeReferenceId: 0,
      SendtoAlternate: false,
      TransactionTypeId: ETransactionTypes.CallRecording,
      Ip: '',
      SentTo: 386,
      SentRegisteredEmail: this.mailfullContent.SentRegisteredEmail,
      CollectionCall: false,
      PhoneCallId: this.PhoneCallId,
      TenantID: this.tenantId,
    };
    emailList.push(emailBody);
    this.twoWayService.sendEmail(emailList).subscribe((response: ISendEmailOutput[]) => {
      if (response && response.length > 0 && response[0].Success) {
        this.toastr.success('Email Sent Successfully', 'Success', this.toasterConfig);
        if(response[0].EmailAttachmentError == 'File size is more than 25MB'){
          this.toastr.warning('Call Recording file could not be attached as it exceeds the size limit',  'Alert', this.toasterConfig);
        }
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.toastr.error('Failed to send email', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    });
    this.CallRecordings.show();
    this.modalRefCall.hide();
  }

  generateToAddressList(data) {
    if (data.split(';').length > 1) {
      let tempToAddressList = data.split(';');
      let toAddressList = [];
      tempToAddressList.forEach(element => {
        let obj = {
          Name: "",
          Email: element
        }
        toAddressList.push(obj);
      });
      toAddressList = toAddressList.filter(e => e.Email !== this.emailfullContent.EmailModel.ToAddress)
      return toAddressList;
    }
    else {
      return [];
    }
  }

  generateCCAddressList(data) {
    if (data.split(';').length > 1) {
      let tempCCAddressList = data.split(';');
      let ccAddressList = [];
      tempCCAddressList.forEach(element => {
        let obj = {
          Name: "",
          Email: element
        }
        ccAddressList.push(obj);
      });
      ccAddressList = ccAddressList.filter(e => e.Email !== this.emailfullContent.EmailModel.CcAddress)
      return ccAddressList;
    }
    else {
      return [];
    }
  }

  colonSepToAddressEmail = (control: AbstractControl): { [key: string]: any } | null => {
    const emails = control.value.split(';');
    const forbidden = emails.some(email => Validators.email(new FormControl(email)));
    let emailFormat = new RegExp('^[^@]+@[a-zA-Z0-9._-]+\\.+[a-z._-]+$');
    let top = emails.every(email => emailFormat.test(email))
    return (!forbidden && top) ? null : { 'toAddress': { value: control.value } };
  };

  colonSepCCAddressEmail = (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value) {
      const emails = control.value.split(';');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      let emailFormat = new RegExp('^[^@]+@[a-zA-Z0-9._-]+\\.+[a-z._-]+$');
      let top = emails.every(email => emailFormat.test(email))
      return (!forbidden && top) ? null : { 'ccAddress': { value: control.value } };
    }
  };

  disableSendEmail() {
    this.sendEmailForm.patchValue({
      toAddress: this.toEmailAddress,
      ccAddress: this.ccEmailAddress
    });

    if ((this.sendEmailForm.valid && this.toEmailAddress !== '') && this.selectedEmailTemplate !== 0
      && this.mailfullContent) {
      return false;
    } else {
      return true;
    }
  }

  setUserPermissions() {
    this.viewRight = this.generalService.getUserPermissionsForModule(EUserFunctions['Call Recording']).ViewRight;
    this.viewRightFalseMessage = this.generalService.ViewRightFalseMessage;
    this.initialPage = { pageSizes: true, pageCount: 10 };
    this.filterSettings = { mode: 'Immediate', immediatemodedelay: 100 };
    this.lines = 'Both';
  }

  onCallReportView() {
    this.loaderIcon = Promise.resolve(true);
    const datepipe: DatePipe = new DatePipe('en');
    this.periodToDateCall = datepipe.transform(new Date(this.periodToDateCall), 'MM/dd/yyyy');
    this.periodFromDateCall = datepipe.transform(new Date(this.periodFromDateCall), 'MM/dd/yyyy');
    const reportParameters = {
      ToDate: this.periodToDateCall,
      FromDate: this.periodFromDateCall,
      UserIds: "0",
      SortDirection: "Desc",
      TenantId: this.tenantId
    };

    const inputModel = {
      ReportName: 'PhoneCalls',
      ReportParameters: reportParameters,
      SortBy: 0,
      StorageFacilities: this.facilityId ? [this.facilityId] : []
    };

    const openInNewTab = '_blank';
    this.reportService.generateReport(inputModel).subscribe((response: IReportResponse) => {
      if (response.Success) {
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.toastr.error('Call Recording Report generation Failed', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  getReportUrl() {
    this.generalService.getReportUrl().subscribe((response: any) => {
      this.reportUrl = response;
    });
  }

  changeperiodFromDateCall(value) {
    this.minPeriodToDateCall = value;
    if ((this.periodToDateCall !== '') && (this.periodToDateCall != null)) {
      if (value.getTime() > this.periodToDateCall.getTime()) {
        this.periodToDateCall = null;
      }
    }
  }

  setUserPermissionsDownload() {
    this.viewRightForDownload = this.generalService.getUserPermissionsForModule(EUserFunctions['Call Recording - Download']).ViewRight;
  }

  setUserPermissionsEmail() {
    this.viewRightForEmail = this.generalService.getUserPermissionsForModule(EUserFunctions['Call Recording - Email']).ViewRight;
  }

  getHistory(tenantId: number) {
    if(this.LeaseNumber == null){
      this.prospectsService.getHistory(tenantId).subscribe((response: IHistoryDeails[]) => {
        this.historyDetails = response;
        if (this.historyDetails.length !== 0) {
          this.historyDetails.forEach((item) => {
            if (item.Type.toUpperCase() == "RENTAL") {
              this.selectedLeaseNumber = item.ConfirmationNumber;
            }
          })
        }
      });
    }
  }

  audioLoaded(): void {
    this.audioLoaderIcon = Promise.resolve(false);
  }

  sortComparer(reference, comparer) {
    const callduration = new callDurationPipe();
    reference = callduration.transform(reference);
    comparer = callduration.transform(comparer);
    if (reference < comparer || !reference || reference == 'Indefinite') {
      return -1;
    }
    if (reference > comparer || !comparer || comparer == 'Indefinite') {
      return 1;
    }
    return 0;
  }

  onRelinkClick(event: MouseEvent, data: any) {

    this.loaderIcon = Promise.resolve(true);
    event.stopPropagation();
    this.storeService.getStores().subscribe({
      next: (stores) => {
        this.loaderIcon = Promise.resolve(false);
        this.CallRecordings.hide();
        this.modalRefCall = this.modalWrapper.openComponent(
          RelinkCallComponent,
          {
            initialState: {
              callData: {
                ...data,
                parentModal: this.CallRecordings
              },
              allStores: stores
            },
            class: 'modal-xl modal-dialog-centered',
            backdrop: 'static',
            keyboard: false
          }
        );

        this.modalRefCall.content.onRelinkSuccess.subscribe((result) => {
          this.GetPhoneCallList(this.tenantId, this.facilityId);
          this.CallRecordings.show();
          if (result?.success) {
            this.toastr.success('Relink call was successful','Success',this.toasterConfig );
          } else {
            this.toastr.error('Failed to relink call','Failure',this.toasterConfig );
          }
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }
}
